import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';

import { IS_EDITOR_MODE } from 'config/envVariable';
import { langTypes } from 'config/gameLangOptions';
import clientTranslation from './lang-client.json';
import editorTranslation from './lang-editor.json';
import localShare from './local-share.json';
import localClient from './local-client.json';
import localEditor from './local-editor.json';

/**
 * 合併本地化翻譯資源到主要翻譯資源
 * @param {Object} mainRes - 主要翻譯資源 (lang.json)
 * @param {Object} localRes - 本地化翻譯資源 (local-lang.json)
 * @returns {Object} 合併後的翻譯資源
 */
const mergeTranslationResources = (mainRes, localRes) => {
    const mergedResources = { ...mainRes };

    // 遍歷所有語系
    Object.keys(localRes).forEach(lang => {
        if (!mergedResources[lang]) {
            mergedResources[lang] = { translation: {} };
        }

        // 確保 translation 物件存在
        if (!mergedResources[lang].translation) {
            mergedResources[lang].translation = {};
        }

        // 合併翻譯內容，local-lang.json 的內容會覆蓋 lang.json 的相同鍵值
        Object.keys(localRes[lang]).forEach(key => {
            mergedResources[lang].translation[key] = localRes[lang][key];
        });
    });

    return mergedResources;
};

// 合併翻譯資源
const editorLang = mergeTranslationResources(
    mergeTranslationResources(editorTranslation, localShare),
    localEditor
);
console.log('editorLang', editorLang);
const clientLang = mergeTranslationResources(
    mergeTranslationResources(clientTranslation, localShare),
    localClient
);

const resources = IS_EDITOR_MODE ? editorLang : clientLang;
const initLang = navigator.language || langTypes.EN_US;

i18n.use(ICU)
    .use(initReactI18next) // set this i18n instance as react-i18next default usage
    .init({
        resources,
        lng: initLang,
        fallbackLng: langTypes.ZH_TW,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export let i18nLangOfGame = null;

if (IS_EDITOR_MODE) {
    i18nLangOfGame = i18n.createInstance();
    i18nLangOfGame.use(ICU).init({
        resources: editorLang,
        lng: langTypes.ZH_TW,
        fallbackLng: langTypes.ZH_TW,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });
}

export function setI18nLanguage({ lang, editorGameLang } = {}) {
    let promises = [];
    if (lang !== undefined) {
        promises.push(new Promise(res => i18n.changeLanguage(lang, () => res())));
    }
    if (editorGameLang !== undefined && IS_EDITOR_MODE) {
        promises.push(
            new Promise(res => i18nLangOfGame.changeLanguage(editorGameLang, () => res()))
        );
    }
    return Promise.all(promises);
}
